import { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { purpleColors, violetColors, slateColors } from './ContentPages/AppLandingPage/styles';

const CookieBannerContainer = styled.div`
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 2rem);
  max-width: 1100px;
  background: linear-gradient(to right, ${purpleColors[50]}, ${purpleColors[100]});
  border: 1px solid ${purpleColors[100]};
  box-shadow: 0 20px 30px -12px rgba(0, 0, 0, 0.2);
  border-radius: 1rem;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  z-index: 2000;
  box-sizing: border-box;

  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    padding: 1rem 1.5rem;
  }
`;

const CookieText = styled.div`
  color: ${slateColors[800]};
  font-size: 0.95rem;
  line-height: 1.5;
  flex: 1;
`;

const CookieActions = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: flex-start;

  @media (min-width: 640px) {
    justify-content: flex-end;
  }
`;

const CookieButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  border: none;
  cursor: pointer;
  padding: 0.65rem 1.1rem;
  border-radius: 0.65rem;
  font-weight: 700;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  color: ${props => props.$variant === 'primary' ? 'white' : purpleColors[700]};
  background: ${props => props.$variant === 'primary'
    ? `linear-gradient(to right, ${purpleColors[600]}, ${violetColors[600]})`
    : `${purpleColors[50]}`};
  border: 1px solid ${props => props.$variant === 'primary' ? purpleColors[500] : purpleColors[200]};

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 18px -10px rgba(0,0,0,0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const CookieBanner = () => {
  const { t } = useTranslation();
  const [cookieChoice, setCookieChoice] = useState<'accepted' | 'rejected' | null>(() => {
    const stored = localStorage.getItem('chuuchuu_cookie_choice');
    return stored === 'accepted' || stored === 'rejected' ? stored : null;
  });

  const handleCookieChoice = (choice: 'accepted' | 'rejected') => {
    setCookieChoice(choice);
    localStorage.setItem('chuuchuu_cookie_choice', choice);
  };

  if (cookieChoice !== null) {
    return null;
  }

  return (
    <CookieBannerContainer>
      <CookieText>
        {t('cookieBanner.message')}
      </CookieText>
      <CookieActions>
        <CookieButton $variant="primary" onClick={() => handleCookieChoice('accepted')}>
          {t('common.accept')}
        </CookieButton>
        <CookieButton $variant="secondary" onClick={() => handleCookieChoice('rejected')}>
          {t('common.reject')}
        </CookieButton>
      </CookieActions>
    </CookieBannerContainer>
  );
};

export default CookieBanner;
